import { render, staticRenderFns } from "./SectionNewsPage.vue?vue&type=template&id=57a7c7fb&scoped=true&"
import script from "./SectionNewsPage.vue?vue&type=script&lang=js&"
export * from "./SectionNewsPage.vue?vue&type=script&lang=js&"
import style0 from "./SectionNewsPage.vue?vue&type=style&index=0&id=57a7c7fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a7c7fb",
  null
  
)

export default component.exports